import Styles from './Images.module.scss'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'
import { Button } from 'blaze-ui/Button'
import { Images } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import { useMemo } from 'react'
import { useUnsplashImages } from 'hooks/queries/useUnsplashImages'
import { ShimmeringColor } from 'components/BrandWizardVisualAnalysisModal/LoadingState'
import { getVideoMimeType } from 'components/Design/UploadsTab/components/StockVideosGallery'
import { sample } from 'lodash'
import { MediaFilePreview } from './MediaFilePreview'
import { useStockVideos, VIDEO_CATEGORIES } from 'hooks/queries/designer/useStockVideos'

interface Props {
  isDisabled?: boolean
  imageKeywords?: string[]
  isLoading?: boolean
}

export const StockVideos = ({ isDisabled, imageKeywords, isLoading }: Props) => {
  const imagePickerContext = useImagePickerContext()
  const { selectedImages, initialQuery, setProvider } = imagePickerContext
  const query = imageKeywords?.join(' ') || initialQuery || ''
  const unsplashQuery = useUnsplashImages({ query, perPage: 4 })

  const category = useMemo(() => sample(VIDEO_CATEGORIES), [])

  const stockVideosQuery = useStockVideos({
    query,
    pageSize: 24,
    videoType: 'all',
    category: !query ? category : undefined,
  })

  const videos = stockVideosQuery.data?.pages.flatMap((page) => page.videos) || []

  const videoFiles = videos.map((video) => ({
    id: video.id,
    url: video.videos.medium.url,
    source_url: video.videos.medium.url,
    thumbnail_url: video.videos.medium.thumbnail,
    duration: video.duration,
    variants: [],
    mime_type: video.videos.medium.mime_type ?? getVideoMimeType(video.videos.medium.url),
    title: video.id,
    preview_variant_url: video.videos.tiny.url,
  }))

  const isStockLoading = unsplashQuery.isLoading || stockVideosQuery.isLoading

  return (
    <div className={Styles.imagesSection}>
      <div className={Styles.header}>
        <Text variant="largeList">Choose a stock video</Text>
      </div>
      <div className={Styles.imagesCard}>
        <div className={Styles.imagesGrid}>
          {(isLoading || isStockLoading) &&
            Array.from({ length: 4 }).map((_, i) => (
              <ShimmeringColor aspectRatio={1} width={152} height={152} key={i} />
            ))}
          {!isLoading &&
            !isStockLoading &&
            Array.from({ length: 4 }).map((_, i) => {
              return (
                <MediaFilePreview
                  ariaLabel="pixabay-video"
                  key={videoFiles[i].id}
                  mediaFile={videoFiles[i]}
                  showVideoPreview={false}
                  isDisabled={isDisabled}
                  isSelected={videoFiles[i].id === selectedImages[0]?.id}
                />
              )
            })}
        </div>
        <Button frontIcon={Images} variant="tertiary" isDisabled={isDisabled} onPress={() => setProvider('stock')}>
          Browse all videos
        </Button>
      </div>
    </div>
  )
}
